import { Text } from '@cleartax/wg-library-typography';
import { MARKETPLACE_PATH } from '../../../../config/constants';
interface IHeaderLogo {
  href?: string;
}

export const HeaderLogo: React.FC<IHeaderLogo> = ({
  href = MARKETPLACE_PATH,
}) => {
  return (
    <Text type="a" className="cursor-pointer" href={href}>
      <img
        src="https://assets1.cleartax-cdn.com/cleartax/images/1665038118_clearlogo1.svg"
        alt="CT logo"
        className="sm:w-28"
        width={153}
      />
    </Text>
  );
};
